const initialHistorialFiltro = {
    fechaDesdeFormat: '',
    fechaHastaFormat: '',
    typeBusqueda: 0,
    dataHistorial: [],
    counterPage: 0,
    habilitarScroll: true,
};

const initialState = {
    token: null,
    historialFiltro: initialHistorialFiltro,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'TOKEN':
            return {
                ...state,
                token: action.payload,
            };
        case 'HISTORIAL_FILTRO':
            return {
                ...state,
                historialFiltro: {
                    ...state.historialFiltro,
                    ...action.payload,
                },
            };
        case 'HISTORIAL_FILTRO_RESET':
            return {
                ...state,
                historialFiltro: initialHistorialFiltro,
            };
        default:
            return state;
    }
};